import observer from '../../util/observer';
import { calcAvailableFilters, checkCurrentFilters } from './action-creators';

export const ratesObserv = observer((state) => state.calculation.results, (dispatch, state) => {
  console.debug('state', state);
  dispatch(calcAvailableFilters());
  dispatch(checkCurrentFilters());
});
